import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { RequireAuth, RequireProject } from './ProtectedRoute';
import { useAuth } from './AuthContext';
import AppShell           from './AppShell';
import LoginPage          from './LoginPage';
import LockedPage         from './LockedPage';
import ProjectSelectPage  from './ProjectSelectPage';
import AdminProjectsPage  from './AdminProjectsPage';
import StandardsPage      from './StandardsPage';
import ThemePage          from './ThemePage';
import SourceTreePage     from './SourceTreePage';
import UploadPage         from './UploadPage';
import ProjectFilesPage   from './ProjectFilesPage';
import AIProcessPage      from './AIProcessPage';
import DownloadPage       from './DownloadPage';

function RootRedirect() {
  const { token, project, syncing } = useAuth();
  if (syncing) return null;
  if (!token)   return <Navigate to="/login"    replace />;
  if (!project) return <Navigate to="/projects" replace />;
  return <Navigate to="/app/workspace?tab=source" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Root — smart redirect based on auth state */}
          <Route path="/" element={<RootRedirect />} />

          {/* Public */}
          <Route path="/login"  element={<LoginPage />} />
          <Route path="/locked" element={<LockedPage />} />

          {/* Auth required — project selection */}
          <Route
            path="/projects"
            element={
              <RequireAuth>
                <ProjectSelectPage />
              </RequireAuth>
            }
          />

          {/* Auth + project required — main app */}
          <Route
            path="/app"
            element={
              <RequireProject>
                <AppShell />
              </RequireProject>
            }
          >
            <Route index                    element={<Navigate to="workspace?tab=source" replace />} />
            <Route path="projects"          element={<AdminProjectsPage />} />
            <Route path="standards"         element={<StandardsPage />} />
            <Route path="theme"             element={<ThemePage />} />
            <Route path="source"            element={<SourceTreePage />} />
            <Route path="files"             element={<ProjectFilesPage />} />
            <Route path="workspace"         element={<AIProcessPage />} />
            <Route path="download"          element={<DownloadPage />} />
            <Route path="upload"            element={<UploadPage />} />
          </Route>

          {/* Catch-all → login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
